import { useMutation, useQueryClient } from "react-query";
import { api } from "../../utils/api/api";

const saveMarginalizedGroupTags = async (
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError,
  values
) => {
  try {
    const formattedData = { ...values, scholarshipId };

    const returnData = await api.post(
      `${process.env.REACT_APP_API_URL}tracs_v3/scholarships/Scholarship_application_protected_api/setMarginalizedGroupTags`,
      formattedData,
      { token }
    );

    return returnData;
  } catch (err) {
    if (err?.httpStatus === 401) {
      handleInvalidToken();
    } else if (err?.httpStatus === 500) {
      handleAPIError();
    }
    console.log(err);
    throw new Error(err);
  }
};

export function useSaveMarginalizedGroupTags(
  scholarshipId,
  token,
  handleInvalidToken,
  handleAPIError,
  values
) {
  const queryClient = useQueryClient();
  return useMutation(
    () => {
      return saveMarginalizedGroupTags(
        scholarshipId,
        token,
        handleInvalidToken,
        handleAPIError,
        values
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("scholarshipApp");
      },
      retry: 0,
    }
  );
}
